<template>
  <div class="home-programs">
    <div class="pdv-container">
      <div class="home-programs-content">
        <h3 class="programs-title"> <u>Beneficios</u> de estudiar en el Preu PDV</h3>
        <div class="content-programs">
          <div class="flex-1 h-full"
            v-for="(program) in programs"
            :key="program.id"
          >
            <div class="card-program h-full">
              <div class="img-content">
                <img :src="program.icon"  :alt="program.text" class="" >
              </div>
              <div class="text-content" v-html="program.text"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img src="/images/featured/arrow-midle.svg"  alt="arrow" class="arrow-midle" >
  </div>
  
</template>
<script>
export default {
  data(){
    return {
      programs: [
        {
          id: 1, icon: '/images/featured/icon-copa.svg', text: '<p>Líder de Puntajes </p>'
        },
        {
          id: 2, icon: '/images/featured/icon-checks.svg', text: '<p>Excelencia <br> Académica</br></p>'
        },
        {
          id: 3, icon: '/images/featured/icon-note.svg', text: '<p>Programas<br>Personalizados</br></p>'
        },
        {
          id: 4, icon: '/images/featured/icon-corazon.svg', text: '<p>Variedad de <br>precios para</br>todos</p>'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .home-programs{
    width: 100%;
    position: relative;
    @media (max-width: 768px) {
      padding: 40px 0;
    }
    @media (min-width: 769px) {
      padding: 40px 0px 80px 0;
    }

    .home-programs-content{
      display: flex;
      flex-direction: column;
      
      @media (max-width: 768px) {
        margin: 0 24px;
      }
      @media (min-width: 769px) {
        margin: 0 76px;
      }
    }
    .programs-title{
      color: $neutralBlack;
      font-family: 'Poppins-ExtraBold', sans-serif;
      @media (max-width: 768px) {
        margin-bottom: 32px;
        font-size: 27px;
        line-height: 27px;
      }
      @media (min-width: 769px) {
        margin-bottom: 48px;
        font-size: 48px;
        line-height: 58px;
      }
    }
    .content-programs{
      @media (max-width: 768px) {
        flex-direction: column;
      }
      @media (min-width: 769px) {
        flex-direction: row;
      }
    }

    .content-programs{
      display: flex;
      
      @media (max-width: 768px) {
        flex-direction: column;
        gap: 16px;
      }
      @media (min-width: 769px) {
        flex-direction: row;
        justify-content: space-between;
        gap: 32px;
      }

      .card-program{
        background: $neutral05;
        height: 166px;
        border: solid 2px $colorTerciario;
        border-radius: 8px 24px 8px 8px;
        
        @media (max-width: 768px) {
          flex-direction: row;
          align-items: center;
          padding: 16px;
        }
        @media (min-width: 769px) {
          flex-direction: column;
          padding: 16px;
        }
        .img-content{
          @media (max-width: 768px) {
            margin-right: 16px;
          }
          @media (min-width: 769px) {
            margin-bottom: 16px;
          }
        }
        
      }
    }
  }
  .arrow-midle{
    position: absolute;
    @media (max-width: 768px) {
      top: -12px;
      right: 0;
    }
    @media (min-width: 769px) {
      top: -22px;
      right: 0;
      height: 176px;
    }
  }
</style>

<style lang="scss">
  .home-programs{
    .card-program{
      .text-content{
        p{
          margin-bottom: 0;
          font-family: 'Poppins-Regular', sans-serif;
          color: $colorTerciario;
          font-size: 14px;
          line-height: 22px;
          font-weight: bold;
          span{
            font-weight: bold;
            font-family: 'Poppins-Regular', sans-serif;
            color: $colorTerciario;
            font-size: 14px;
            line-height: 22px;
          }
        }
      }
    }
  }
</style>